import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { Field } from "formik";
import { isFunction, omit } from "lodash";
import { Col, Row, Form } from "react-bootstrap";

const FieldRenderer = (props) => {
  const [left, setLeft] = useState(0);

  const {
    name,
    validate,
    label,
    error,
    touched,
    submitcount,
    labelwidth,
    inputwidth,
    max_allowed,
    ismultiple,
    value,
    onChange,
    format,
    required,
  } = props;

  useEffect(() => {
    let entered_values = 0;
    if (value) {
      entered_values = value.toString().split(",").length;
    }
    setLeft(max_allowed - entered_values);
  }, [value, max_allowed]);

  const handleChange = (e) => {
    if (onChange) onChange(e);
    if (ismultiple) {
      let values = e.currentTarget.value.split(","),
        valid = 0;
      values.forEach((element) => {
        if (format && format.test(element.trim())) {
          valid++;
        }
      });
      setLeft(max_allowed - valid);
    }
  };

  const validateField = useCallback(
    (value) => {
      let error;
      if (required && (value === undefined || value === "" || value === false)) {
        error = "This field is required";
      } else if (format && value) {
        if (ismultiple) {
          let values = value.split(","),
            invalidValues = [];
          values.forEach((element) => {
            if (format && !format.test(element.trim()) && element) {
              invalidValues.push(element);
            }
          });
          if (invalidValues.length > 0) {
            error = "Invalid values: " + invalidValues.join(", ");
          }
          if (left <= -1) {
            error = "You entered more " + label.toLowerCase();
          }
        } else {
          if (!format.test(value)) {
            error = label ? "Invalid " + label.toLowerCase() : "Invalid details entered";
          }
        }
      }
      return error;
    },
    [format, required, label, ismultiple, left]
  );

  const propsToPass = omit(props, [
    "name",
    "validate",
    "label",
    "error",
    "touched",
    "labelwidth",
    "inputwidth",
    "min",
    "max",
    "required",
    "format",
  ]);

  const className =
    (error && (touched || !!submitcount) ? "error is-invalid" : "") +
    " text-input form-control " +
    (props.className ? props.className : "");

  return (
    <React.Fragment>
      <Form.Group as={Row} controlId={`formHorizontal_${label}`} className="mb-3">
        {label && (
          <Form.Label column sm={labelwidth || 3}>
            {label}
            {required && <span className="required_asterisk"> *</span>}
          </Form.Label>
        )}
        <Col sm={inputwidth || 6}>
          <Field
            name={name}
            id={name}
            {...propsToPass}
            className={className}
            validate={isFunction(validate) ? validate : validateField}
            onChange={handleChange}
          />
          {ismultiple && max_allowed && (
            <div className="hint mt-2">
              comma separated, {max_allowed} allowed
              <span className="red"> ({left >= 0 ? left : 0} left)</span>
            </div>
          )}
          {error && (touched || !!submitcount) && <div className="invalid-feedback">{error}</div>}
        </Col>
      </Form.Group>
    </React.Fragment>
  );
};

FieldRenderer.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.func,
  label: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.any,
  submitcount: PropTypes.number,
  labelwidth: PropTypes.number,
  inputwidth: PropTypes.number,
  max_allowed: PropTypes.number,
  ismultiple: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  format: PropTypes.instanceOf(RegExp),
  required: PropTypes.bool,
  className: PropTypes.string,
};

export default FieldRenderer;
